"use strict";
// J-262 (C4), J-274 (NR-05): whether a patient is inactive, why, and since when, from the dates on the
// deciding A row's person line (`core.bundle_person.death_date`, `discharge_date`). Deceased wins when
// both are on file. Display only: no figure reads it, so an inactive patient stays in the measure. Pure.
Object.defineProperty(exports, "__esModule", { value: true });
exports.INACTIVE_REASONS = void 0;
exports.inactiveOf = inactiveOf;
exports.inactiveReasonWord = inactiveReasonWord;
/** J-274 (NR-05): why a patient is inactive; the screens word each through `ui.yaml` `text`. */
exports.INACTIVE_REASONS = ["DECEASED", "DISCHARGED"];
function inactiveOf(dates) {
    if (dates.deathDate !== null)
        return { inactive: true, inactiveReason: "DECEASED", inactiveDate: dates.deathDate };
    if (dates.dischargeDate !== null)
        return { inactive: true, inactiveReason: "DISCHARGED", inactiveDate: dates.dischargeDate };
    return { inactive: false, inactiveReason: null, inactiveDate: null };
}
/** The reason in the configured words (`ui.yaml` `text.inactive_deceased`, `inactive_discharged`). */
function inactiveReasonWord(text, reason) {
    if (reason === null)
        return null;
    return reason === "DECEASED" ? text.inactive_deceased : text.inactive_discharged;
}
//# sourceMappingURL=inactive.js.map